import { Match } from '../types/Match';
import { apiGet } from './apiClient';

export function getAllMatches(): Promise<Match[]> {
  return apiGet<Match[]>('/api/Match/all', true, { bypassCache: true });
}

export function getKnockoutMatches(): Promise<Match[]> {
  return apiGet<Match[]>('/api/Match/Knockout', true, { bypassCache: true });
}
